import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { INavigationFavorite, INavigationItem } from './navigation.model';

export const addFavorite = createAction(
  '[Navigation] Add Navigation Favorite',
  props<{ favorite: INavigationFavorite }>()
);

export const addFavoriteFailure = createAction(
  '[Navigation] Add Navigation Favorite Failure',
  props<{ favorite: INavigationFavorite, error: HttpErrorResponse }>()
);

export const deleteFavorite = createAction(
  '[Navigation] Delete Navigation Favorite',
  props<{ favorite: INavigationFavorite }>()
);

export const deleteFavoriteFailure = createAction(
  '[Navigation] Delete Navigation Favorite Failure',
  props<{ favorite: INavigationFavorite, error: HttpErrorResponse }>()
);

export const updateFavorites = createAction(
  '[Navigation] Update Navigation Favorites',
  props<{ oldFavorites: INavigationFavorite[], newFavorites: INavigationFavorite[] }>()
);

export const updateFavoritesFailure = createAction(
  '[Navigation] Update Navigation Favorites Failure',
  props<{ oldFavorites: INavigationFavorite[], error: HttpErrorResponse }>()
);

export const getNavItems = createAction(
  '[Navigation] Retrieve Navigation'
);

export const getNavItemsSuccess = createAction(
  '[Navigation] Retrieve Navigation Success',
  props<{ navItems: INavigationItem[] }>()
);

export const getNavItemsFailure = createAction(
  '[Navigation] Retrieve Navigation Failure',
  props<{ error: HttpErrorResponse }>()
);

export const getNavFavorites = createAction(
  '[Navigation] Get Navigation Favorites'
);

export const getNavFavoritesSuccess = createAction(
  '[Navigation] Get Navigation Favorites Success',
  props<{ favorites: INavigationFavorite[] }>()
);

export const getNavFavoritesFailure = createAction(
  '[Navigation] Get Navigation Favorites Failure',
  props<{ error: HttpErrorResponse }>()
);

export const hideNavigation = createAction(
  '[Navigation] Hide navigation',
  props<{ shouldHide: boolean }>()
);


